<template>
  <v-data-table
      :items="items"
      hide-default-footer
      no-data-text="Please, add samples"
      :headers="headers"
      :items-per-page="-1"
      hide-default-header>
    <template v-slot:header="{ props: { headers } }">
      <thead>
      <tr>
        <th v-for="header in headers"
            :key="header.text" :width="header.width" :align="header.align">
                        <span v-if="header.type === 'fertilizationMethodSelector' && items.length > 0">
                            <v-radio-group v-model="fertilizationMethod" row :mandatory="false" class="small"
                                           @change="handleChangeFertilizationMethod">
                                <v-radio label="ЭКО" value="ivf" xs></v-radio>
                                <v-radio label="ИКСИ" value="icsi"></v-radio>
                            </v-radio-group>
                        </span>
          <span v-else v-html="header.text"></span>
        </th>
      </tr>
      </thead>
    </template>
    <template v-slot:item="props">
      <Item :data="props.item"
            :ref="uniqueId()"
            :suitableBatch="suitableBatch"
            :sampleExistChecker="checkSampleExist"
            :selectedClientId="selectedClientId"
            @delete="handleItemDelete"
            @target-changed="handleTargetChanged"
            @close-sample-edit-menu="$emit('close-sample-edit-menu')"
            @validation-changed="handleChangeItemValidationChanged(props.item, $event)"
      />
    </template>
  </v-data-table>

</template>

<script>
import _ from 'lodash'
import Item from './Item'

export default {
  name: 'List',
  props: {
    items: Array,
    suitableBatch: Object,
    selectedClientId: String,
  },
  components: {
    Item
  },
  data() {
    return {
      formValid: false,
      fertilizationMethod: null
    }
  },
  computed: {
    headers() {
      let result = [
        {
          text: 'For<br/>analysis',
          type: 'analysis',
          sortable: false,
          align: 'left',
          width: '50px'
        },
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          width: '100px'
        },
        {
          text: 'Application</br>date',
          align: 'left',
          sortable: false,
          width: '100px'
        },
        {
          text: 'Fertilization method',
          align: 'left',
          sortable: false,
          type: 'fertilizationMethodSelector',
          width: '50px'
        },
        {
          text: 'Plate</br>status',
          align: 'left',
          sortable: false,
          width: '200px'
        },
        {
          text: 'Actions',
          align: 'left',
          sortable: false,
          width: '50px'
        }
      ]

      return result
    }
  },
  mounted() {
    this.formValid = this.validate()
  },
  methods: {
    handleItemDelete(id) {
      this.$emit('delete', id)
    },
    handleChangeFertilizationMethod(fertilizationMethod) {
      this.$emit('change-fertilization-method-for-all', fertilizationMethod)
    },
    checkSampleExist(checkingItem, title) {
      let result = true

      if (!title) {
        return result
      }

      for (let item of this.items) {
        const itemId = _.get(item, 'tempId')
        const checkingItemId = _.get(checkingItem, 'tempId')
        //console.log(itemId, checkingItemId, item.title, title)
        if (item.title === title && itemId !== checkingItemId) {
          result = false
          break
        }
      }

      return result
    },
    handleChangeItemValidationChanged() {
      this.validate()
    },
    validate(silent = false) {
      let result = true

      for (let key in this.$refs) {
        if (!this.$refs.hasOwnProperty(key)) {
          continue
        }

        const item = _.get(this.$refs, key)

        if (!item) {
          delete this.$refs[key]
          continue
        }

        if (!item.validate()) {
          result = false
          break
        }
      }

      if (this.formValid !== result) {
        this.formValid = result

        if (!silent) {
          this.$emit('validation-changed', result)
        }
      }

      return result
    },
    isValid() {
      return this.formValid
    },
    uniqueId() {
      return _.uniqueId('item-')
    },
    handleTargetChanged(value) {
      this.$emit('sample-target-changed', value)
    }
  }
}
</script>

<style scoped>

</style>